import { useEffect, useState } from 'react';
import { Api } from '../../componentes/Api';
import { Card, Col,Row, CardBody, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import Moment from "moment";
import moment from "moment";
import * as XLSX from "xlsx"
import { saveAs } from "file-saver";
import QRScanner from "../../componentes/QRScanner";

const modeloDatos = {
    registroID:0,
      empresaID: 1,
       comercio: ''
    , rnc: "",
    mes: 0,
    ano:0
    , ncf: ""
    , fechaFactura: new Date,
     fecha: new Date,
     montoItbs: ""
    , montoTotal: ""
    , comentario: "",
    formaPago:"01",
      creadoPor: "",
    modificadoPor: "",
    fechaCreado: new Date,
    fechaModificado: new Date

}

const Seleccion = {
    mes: new Date().getMonth() + 1,
    ano: new Date().getFullYear()
}

const R_F_NCF = () => {
    const [tabla, setTabla] = useState(modeloDatos);
    const [Listado, SetListado] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);
    const [fechaInicio, setFechaInicio] = useState(new Date());
    const [user, setUser] = useState(window.localStorage.getItem("sesion_usuario"))
    const [Visualizar, setVisualizar] = useState(false);
    const [Impresion, setImpresion] = useState(false);
    const [Select, setSelect] = useState(Seleccion);
    const [R_API, setR_API] = useState("")
    const [qrText, setQrText] = useState("");
    const TIPOS_NCF_VALIDOS = new Set(["01", "02", "03", "04", "11", "12", "13", "14", "15", "16", "17"]);

    const esRncValido = (rnc) => rnc?.length === 9 || rnc?.length === 11;
    const esNcfValido = (ncf) => ncf?.length === 11 || ncf?.length === 13;
    const formaPagoTexto = (codigo) => {
        const opciones = {
            "01": "Efectivo",
            "02": "Cheque/Transferencia/Depósito",
            "03": "Tarjeta",
            "04": "Crédito",
            "Otro": "Otro"
        };
        return opciones[codigo] || codigo || "";
    };
    const limpiarSoloNumeros = (v) => (v || "").toString().replace(/\D/g, "");
    const normalizarNcf = (v) => (v || "").toString().trim().toUpperCase().replace(/\s+/g, "");
    const validarNcfDgii = (ncfValue) => {
        const ncf = normalizarNcf(ncfValue);
        if (!ncf) return { valido: false, motivo: "Debe indicar el NCF." };
        if (!(ncf.length === 11 || ncf.length === 13)) {
            return { valido: false, motivo: "El NCF debe tener 11 o 13 caracteres." };
        }
        if (/^\d{11}$|^\d{13}$/.test(ncf)) {
            return { valido: true, motivo: "" };
        }
        if (ncf.length === 11 && /^B\d{10}$/.test(ncf)) {
            const tipo = ncf.substring(1, 3);
            return TIPOS_NCF_VALIDOS.has(tipo)
                ? { valido: true, motivo: "" }
                : { valido: false, motivo: `Tipo NCF no valido: ${tipo}.` };
        }
        if (ncf.length === 13 && /^E\d{12}$/.test(ncf)) {
            const tipo = ncf.substring(1, 3);
            return TIPOS_NCF_VALIDOS.has(tipo)
                ? { valido: true, motivo: "" }
                : { valido: false, motivo: `Tipo e-CF no valido: ${tipo}.` };
        }
        return { valido: false, motivo: "Formato NCF no reconocido. Ej: B0100000001 o E310000000001." };
    };
    const extraerMonto = (v) => {
        if (v === null || v === undefined) return "";
        const limpio = v.toString().replace(/[^0-9.,-]/g, "").replace(",", ".");
        const n = Number(limpio);
        return Number.isFinite(n) ? n : "";
    };
    const normalizarFecha = (v) => {
        if (!v) return "";
        const raw = v.toString().trim().replace(/^'(.*)'$/, "$1");
        const formatos = [
            "YYYY-MM-DD",
            "DD-MM-YYYY",
            "DD/MM/YYYY",
            "YYYY/MM/DD",
            "MM/DD/YYYY",
            "DD.MM.YYYY"
        ];
        for (const f of formatos) {
            const m = moment(raw, f, true);
            if (m.isValid()) return m.format("YYYY-MM-DD");
        }
        const m = moment(new Date(raw));
        return m.isValid() ? m.format("YYYY-MM-DD") : "";
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        const nextValue = name === "rnc"
            ? limpiarSoloNumeros(value)
            : name === "ncf"
                ? normalizarNcf(value)
                : value;
        setTabla((prev) => ({
            ...prev,
            [name]: nextValue
        }));
        if (name === "rnc" && esRncValido(nextValue)) {
            ValidarRNC(nextValue);
        }
    }


    const ValidarRNC = async (x, extra = {}) => {
       let response1 = await fetch(Api + "DGII/ConsultaDGII" + "/" + x);
        if (response1.ok) {
            let data1 = await response1.json()
            const nextRnc = limpiarSoloNumeros(x);
            const nextNcf = extra.ncf ? normalizarNcf(extra.ncf) : undefined;
            const nextFecha = extra.fechaFactura ? normalizarFecha(extra.fechaFactura) : undefined;
            const nextMonto = extra.montoTotal !== undefined ? extraerMonto(extra.montoTotal) : undefined;
            const nextItbs = extra.montoItbs !== undefined ? extraerMonto(extra.montoItbs) : undefined;

            if (data1 != false) {
                setTabla((prev) => ({
                    ...prev,
                    comercio: (data1).descripcion || prev.comercio,
                    rnc: nextRnc,
                    ...(nextNcf !== undefined ? { ncf: nextNcf } : {}),
                    ...(nextFecha !== undefined ? { fechaFactura: nextFecha } : {}),
                    ...(nextMonto !== undefined ? { montoTotal: nextMonto } : {}),
                    ...(nextItbs !== undefined ? { montoItbs: nextItbs } : {})
                }));
            } else {
                setTabla((prev) => ({
                    ...prev,
                    comercio: "",
                    rnc: nextRnc,
                    ...(nextNcf !== undefined ? { ncf: nextNcf } : {}),
                    ...(nextFecha !== undefined ? { fechaFactura: nextFecha } : {}),
                    ...(nextMonto !== undefined ? { montoTotal: nextMonto } : {}),
                    ...(nextItbs !== undefined ? { montoItbs: nextItbs } : {})
                }));
            }
        }
    }
    const parseQrData = (text) => {
        const raw = (text || "").toString().trim();
        if (!raw) return null;

        const resultado = {};
        const asignar = (k, v) => {
            if (!v) return;
            const key = k.toLowerCase();
            if (["rncemisor", "rnc", "rnc_emisor"].includes(key)) resultado.rnc = limpiarSoloNumeros(v);
            if (["encf", "ncf", "numerocomprobantefiscal"].includes(key)) resultado.ncf = normalizarNcf(v);
            if (["fechaemision", "fecha", "fechafactura"].includes(key)) resultado.fechaFactura = normalizarFecha(v);
            if (["montototal", "total"].includes(key)) resultado.montoTotal = extraerMonto(v);
            if (["itbis", "montoitbs", "itbismonto"].includes(key)) resultado.montoItbs = extraerMonto(v);
        };

        const parseFromParams = (params) => {
            for (const [k, v] of params.entries()) asignar(k, v);
        };

        try {
            const url = new URL(raw);
            parseFromParams(url.searchParams);
        } catch {
            const textoPlano = raw.replace(/\?/g, "&").replace(/\n/g, "&").replace(/;/g, "&");
            parseFromParams(new URLSearchParams(textoPlano));
            const rncRegex = raw.match(/\b\d{9}\b|\b\d{11}\b/);
            const ncfRegex = raw.match(/\b[A-Za-z]\d{10,12}\b|\b\d{11,13}\b/);
            const fechaRegex = raw.match(/\b\d{2}[\/.-]\d{2}[\/.-]\d{4}\b|\b\d{4}[\/.-]\d{2}[\/.-]\d{2}\b/);
            const totalRegex = raw.match(/(?:MontoTotal|Total)\s*[:=]\s*([0-9.,]+)/i);
            if (!resultado.rnc && rncRegex) resultado.rnc = limpiarSoloNumeros(rncRegex[0]);
            if (!resultado.ncf && ncfRegex) resultado.ncf = normalizarNcf(ncfRegex[0]);
            if (!resultado.fechaFactura && fechaRegex) resultado.fechaFactura = normalizarFecha(fechaRegex[0]);
            if (!resultado.montoTotal && totalRegex?.[1]) resultado.montoTotal = extraerMonto(totalRegex[1]);
        }

        return resultado;
    };

    const handleQrResult = async (text) => {
        const datos = parseQrData(text);
        if (!datos || !datos.rnc) {
            Swal.fire('QR', 'No pude identificar un RNC valido en el QR.', 'warning');
            return;
        }
        await ValidarRNC(datos.rnc, datos);
        setQrText(text || "");
        Swal.fire('QR', 'Datos del QR cargados en el formulario.', 'success');
    };

    const procesarTextoQr = async () => {
        await handleQrResult(qrText);
    };
    const diagnosticoNcf = tabla.ncf ? validarNcfDgii(tabla.ncf) : null;

    const nuevo = () =>{
        setVerModal(!verModal);
        setTabla(modeloDatos);
        // === Tu código tal cual ===
   
      
    }

    const handleChange1 = (e) => {
        setSelect({
            ...Select,
            [e.target.name]: e.target.value
        })       
    }

    let correo = JSON.parse(user).correo;
    const obtenerDatos = async () => {
        let response = await fetch(Api + "DGII/ListaRegistroFacturaNCF" + "/" + correo + "/" + Select.mes + "/" + Select.ano);
        if (response.ok) {
            let data = await response.json()
            SetListado(data);
            setPendiente(false);
            setR_API(Api + "DGII/ListaRegistroFacturaNCF" + "/" + correo + "/" + Select.mes + "/" + Select.ano)

        }
    }

    useEffect(() => {
        obtenerDatos();
    }, [Select])


    const mostrarMensaje = () => {
        Swal.fire({
            title: 'ERROR',
            text: "No puedes guardar si hay un elemento Activo.  Favor inactivar el elemento. ",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            //confirmButtonText: 'Si, continuar',
            cancelButtonText: 'volver'
        }).then((result) => {
            //alert(result.value)
            if (result.value) {


            }
        })

    }


    const guardarCambios = async () => {
        let response;

        if (!esRncValido(tabla.rnc)) {
            Swal.fire('Validación', 'El RNC debe tener 9 u 11 dígitos.', 'warning');
            return;
        }
        if (!esNcfValido(tabla.ncf)) {
            Swal.fire('Validación', 'El NCF debe tener 11 o 13 caracteres.', 'warning');
            return;
        }
        const valNcf = validarNcfDgii(tabla.ncf);
        if (!valNcf.valido) {
            Swal.fire('Validación', valNcf.motivo, 'warning');
            return;
        }
        if (!tabla.fechaFactura) {
            Swal.fire('Validación', 'Debe indicar la fecha de factura.', 'warning');
            return;
        }

        const payload = {
            ...tabla,
            ano: new Date(tabla.fechaFactura).getFullYear(),
            mes: new Date(tabla.fechaFactura).getMonth() + 1,
            fechaFactura: new Date(tabla.fechaFactura),
            montoItbs: Number(tabla.montoItbs) || 0,
            montoTotal: Number(tabla.montoTotal) || 0,
            formaPago: tabla.formaPago || "01"
        };

        if (tabla.registroID == 0) {          
            payload.creadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "DGII/GuardarRegistroFacturaNCF", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(payload)
            })
            setVerModal(!verModal);
        } else {
            payload.modificadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "DGII/EditarRegistroFacturaNCF", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(payload)
            })
        }

        if (response.ok) {
            Swal.fire(
                'Guardado!',
                '',
                'success'
            )
            obtenerDatos();

            if (payload.activa == false) {
                setTabla(modeloDatos);
                setVerModal(!verModal);
               
            }
            let data1 = await response.json()

            if (data1 == false) {
                mostrarMensaje()
            } else {
                //await obtenerDatos();
                setTabla(modeloDatos)
                setVerModal(!verModal);
            }
            obtenerDatos()
        } else {
            alert("error al guardar")
        }
        setPendiente(true)
        obtenerDatos()
    }

    const eliminarDatos = async (id) => {

        Swal.fire({
            title: 'Esta seguro?',
            text: "Desea eliminar el producto",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'No, volver'
        }).then((result) => {
            if (result.value) {
                const response = fetch(Api + "Citas/EliminarEspecialistas/" + id, { method: "DELETE" })
                    .then(response => {
                        if (response.ok) {
                            //obtenerDatos();
                            Swal.fire(
                                'Eliminado!',
                                'El producto fue eliminado.',
                                'success'
                            )
                        }
                    })
            }
        })
    }

    const exportarExcel = () => {
        var wb = XLSX.utils.book_new();
        
        var list = Listado.map(x => ({
            RNC: x.rnc, Comercio: x.comercio, NCF: x.ncf, Fecha: moment(x.fechaFactura).format("DD/MM/YYYY"),
            MontoITBS:x.montoItbs,MontoTotal: x.montoTotal, FormaPago:formaPagoTexto(x.formaPago) ,Comentario:x.comentario
        }));
        var ws = XLSX.utils.json_to_sheet(list);
        XLSX.utils.book_append_sheet(wb, ws, "Reporte");
        XLSX.writeFile(wb, "Reporte Factura NCF" + Select.mes +Select.ano+".xlsx")
    }

    const exportarExcelDGII = () => {
        let response = fetch(Api + "DGII/ExportarExcel" );
        if (response.ok) {
            let data = response.json()
            alert();

        }

     //let   response =  fetch(Api + "DGII/ExportarExcel", {
     //       method: 'POST',
     //       headers: {
     //           'Content-Type': 'application/json;charset=utf-8'
     //       },
     //       body: JSON.stringify(tabla)
     //   })
        Swal.fire(
            'Se genero el excel de validacion!',
            'Revisar su inidad C: carpeta DGII',
            'success'
        )
    }

    const abrirEditarModal = (data) => {
        setTabla(data);
        setVerModal(!verModal);
    }
    const cerrarModal = () => {
        setTabla(modeloDatos)
        setVerModal(false)
    }

    const columns = [
        {
            name: 'RNC',
            selector: row => row.rnc,
            sortable: true,
        },
        {
            name: 'Fecha ',
            selector: row => moment( row.fechaFactura).format("DD/MM/YYYY"),
            sortable: true,
        },
        {
            name: 'Comercio ',
            selector: row => row.comercio,
            sortable: true,
        },
        {
            name: 'NCF ',
            selector: row => row.ncf,
            sortable: true,
        },
        {
            name: 'ITBS ',
            selector: row => row.montoItbs,
            sortable: true,
        },
        {
            name: 'Monto Total ',
            selector: row => row.montoTotal,
            sortable: true,
        },

        {
            name: '',
            cell: row => (
                <>
                    <Button color="primary" size="sm" className="mr-2"
                        onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>


                </>
            ),
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
                paddingLeft: '5px',
                paddingRight: '5px',
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
                paddingLeft: '5px',
                paddingRight: '5px',
            }
        },
        cells: {
            style: {
               marginRight: '2px',
                paddingLeft: '5px',
                paddingRight: '5px',
            }
        },
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    
    tabla.creadoPor = JSON.parse(user).correo;
    let DGII = JSON.parse(user).dgii;

    const Exp606=()=> {
        let lyrics =
            "606|"+DGII+"|" + Select.ano + Select.mes + "|" + Listado.length+"\n" +
            Listado.map(x =>
                x.rnc + "|1|" + x.ncf + "||" + moment(x.fecha).format("YYYYMMDD") + "|" + moment(x.fecha).format("YYYYMMDD") +
                "|" + x.montoTotal + "|" + "|" + x.montoTotal + "|" + x.montoItbs+"||||" + x.montoItbs+"||||||||"+(x.formaPago || "01")+"\n");

      //  var blob = new Blob([lyrics.replace(',','')], { type: "text/plain;charset=utf-8" });
        var blob = new Blob([lyrics.split(",").join('')], { type: "text/plain;charset=utf-8" });
        saveAs(blob, "DGII_F_606_WEB" + Select.ano + Select.mes + ".txt");
    }

    return (
        <>
            <Card>
                <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                    Lista de Registros de NCF.
                </CardHeader>
                <CardBody>
                    <Row className="align-items-end">
                        <Col sm={2}>
                            <FormGroup>
                            <Button color="success" size="md"
                                onClick={() => nuevo()}
                                >Nuevo Registro</Button>
                                </FormGroup>
                        </Col>

                        <Col sm={2}>
                            <FormGroup>
                                <Label>Mes:</Label>

                                <Input className="form-control" bsSize="sm" type={"select"} onChange={handleChange1} name="mes" value={Select.mes} >
                                    <option value={0}>Todo el Año</option>
                                    <option value={1}>Enero</option>
                                    <option value={2}>Febrero </option>
                                    <option value={3}>Marzo</option>
                                    <option value={4}>Abril </option>
                                    <option value={5}>Mayo</option>
                                    <option value={6}>Junio </option>
                                    <option value={7}>Julio</option>
                                    <option value={8}>Agosto </option>
                                    <option value={9}>Septiembre</option>
                                    <option value={10}>Octubre </option>
                                    <option value={11}>Noviembre</option>
                                    <option value={12}>Diciembre </option>
                                </Input>
                            </FormGroup>
                        </Col>

                        <Col sm={2}>
                            <FormGroup>
                                <Label>Año:</Label>
                                <Input name="ano" id="ano" onChange={handleChange1} value={Select.ano}></Input>
                            </FormGroup>
                        </Col>
                        <Col sm={2}>
                            <FormGroup>
                                <button size="sm" color="primary" className="btn-search" block onClick={() => setImpresion(true)}>
                                    <i className="fas fa-print"></i> Imprimir
                                </button>
                            </FormGroup>
                        </Col>
                        <Col sm={2}>
                            <FormGroup>
                              
                                <Button hidden={ true} color="primery" size="sm" block onClick={exportarExcelDGII}>
                                    <i className="fa fa-file-excel" aria-hidden="true"></i> Exportar Excel DGII
                                </Button>
                                <Button color="primery" size="sm" block onClick={exportarExcel}>
                                    <i className="fa fa-file-excel" aria-hidden="true"></i> Exportar
                                </Button>
                                <Button color="primery" size="sm" block onClick={Exp606}>
                                    <i className="fa fa-file" aria-hidden="true"></i> TXT
                                </Button>
                            </FormGroup>
                        </Col>

                    </Row>
                    <hr></hr>
                    <DataTable
                        columns={columns}
                        data={Listado}
                        progressPending={pendiente}
                        pagination
                        paginationComponentOptions={paginationComponentOptions}
                        customStyles={customStyles}
                    />
                </CardBody>
            </Card>

            <Modal isOpen={verModal}>
                <ModalHeader className="modal-header1">
                    Registro de Factura NCF
                </ModalHeader>
                <ModalBody>

                  

                   

                    <Row>
                        <Col sm={12}>
                            <FormGroup>
                                <Label>Escanear QR</Label>
                                <div style={{ display: "flex", gap: "8px", alignItems: "center", flexWrap: "wrap" }}>
                                    <QRScanner onResult={handleQrResult} />
                                </div>
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={12}>
                            <FormGroup>
                                <Label>Pegar texto o URL del QR</Label>
                                <Input
                                    type="textarea"
                                    rows="2"
                                    bsSize="sm"
                                    value={qrText}
                                    onChange={(e) => setQrText(e.target.value)}
                                    placeholder="Pega aqui el contenido del QR si no quieres usar camara"
                                />
                                <Button size="sm" color="secondary" style={{ marginTop: "8px" }} onClick={procesarTextoQr}>
                                    Procesar QR Pegado
                                </Button>
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={6}>
                            <FormGroup>
                                <Label>RNC </Label>
                                <i hidden={esRncValido(tabla.rnc) || !tabla.rnc} style={{ color: "red" }} className="fas fa-exclamation-circle"></i>
                                <i hidden={!esRncValido(tabla.rnc)} style={{ color: "green" }} className="fas fa-check"></i>
                                <Input disabled={Visualizar} bsSize="sm" name="rnc" onChange={handleChange} value={tabla.rnc} />
                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup>
                                <Label>Comercio</Label>
                                <Input disabled={Visualizar}  bsSize="sm" name="comercio" onChange={handleChange} value={tabla.comercio} />

                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                       <Col sm={6}>
                            <FormGroup>
                                <Label>Fecha de la Factura</Label>
                                <Input disabled={Visualizar} bsSize="sm" type="date" name="fechaFactura" onChange={handleChange} value={Moment(tabla.fechaFactura).format('YYYY-MM-DD')} />

                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup>
                                <Label>NCF </Label>
                                <i hidden={esNcfValido(tabla.ncf) || !tabla.ncf} style={{ color: "red" }} className="fas fa-exclamation-circle"></i>
                                <i hidden={!esNcfValido(tabla.ncf)} style={{ color: "green" }} className="fas fa-check"></i>
                                <Input
                                    disabled={Visualizar}
                                    bsSize="sm"
                                    name="ncf"
                                    maxLength={13}
                                    onChange={handleChange}
                                    value={tabla.ncf}
                                    placeholder="B0100000001 / E310000000001"
                                />
                                {diagnosticoNcf && (
                                    <small style={{ color: diagnosticoNcf.valido ? "green" : "red" }}>
                                        {diagnosticoNcf.valido ? "NCF con formato valido." : diagnosticoNcf.motivo}
                                    </small>
                                )}
                            </FormGroup>
                        </Col>
                       
                    </Row>
                    <Row>
                     <Col sm={6}>
                            <FormGroup>
                                <Label>Monto ITBS</Label>
                                <Input disabled={Visualizar} type="number" bsSize="sm" name="montoItbs" onChange={handleChange} value={tabla.montoItbs} />

                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup>
                                <Label>Monto Total Factura </Label>
                                <Input disabled={Visualizar} type="number" bsSize="sm" name="montoTotal" onChange={handleChange} value={tabla.montoTotal} />

                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup>
                                <Label>Forma de Pago</Label>
                                <Input bsSize="sm" type={"select"} className="form-control" onChange={handleChange} name="formaPago" value={tabla.formaPago} >
                                    <option value={"01"}>Efectivo</option>
                                    <option value={"02"}>Cheque/Transferencia/Depósito</option>
                                    <option value={"03"}>Tarjeta</option>
                                    <option value={"04"}>Crédito</option>
                                    <option value={"Otro"}>Otro</option>
                                    </Input>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <FormGroup>
                                <Label>Comentario</Label>
                                <Input disabled={Visualizar} type="textarea" bsSize="sm" name="comentario" onChange={handleChange} value={tabla.comentario} />

                            </FormGroup>
                        </Col>
                      </Row>
                </ModalBody>
                <ModalFooter>
                    <Button size="sm" color="primary"
                        onClick={guardarCambios}
                    >Guardar</Button>
                    <Button size="sm" color="danger"
                        onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>


            <Modal className="modal-preguntas" isOpen={Impresion} size="xl">
                <ModalHeader className="modal-header1">
                    <div className="box">
                        <div> IMPRESION  </div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={() => setImpresion(false)}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <FormGroup>
                            {<iframe
                                src={
                                    "/Informes/DGII/ReporteFacturaNCF.html?API=" +
                                    encodeURIComponent(R_API) +
                                    "&MES=" + encodeURIComponent(Select.mes) +
                                    "&ANO=" + encodeURIComponent(Select.ano)
                                }
                                title="Contenido HTML"
                                style={{ width: '100%', height: '80vh', border: 'none' }}

                            />}


                            <Button size="sm" color="danger"
                                onClick={() => setImpresion(false)}
                            >Cerrar</Button></FormGroup>
                    </Row>
                </ModalBody>

            </Modal>
        </>
    )

}
export default R_F_NCF;
